import { createSlice } from '@reduxjs/toolkit';

const likeStatusSlice = createSlice({
    name: 'likeStatus',
    initialState: 0,
    reducers: {
        setLikeStatus: (state, action) => action.payload,
    },
});

export const { setLikeStatus } = likeStatusSlice.actions;

export default likeStatusSlice.reducer;
